module.exports = __webpack_public_path__ + "static/media/bottom@2x.5082cd69.png";